import { Component } from 'react';
import { ReactComponent as Delete } from 'assets/images/svg/delete.svg';
import Popup from 'Components/Common/PopUp';

export default class DeleteButton extends Component {
  constructor(props){
    super(props)
    this.state={
      deletepopup:false
    }
  }
  handlePopup = () =>{
    this.setState({ deletepopup: true }, () => {
      const { deletePopupStatus } = this.props;
      if(deletePopupStatus) {
        deletePopupStatus(this.state.deletepopup)
      }
    })
  }
  closePopUp = () => {
    this.setState({ deletepopup:false }, () => {
      const { deletePopupStatus } = this.props;
      if(deletePopupStatus) {
        deletePopupStatus(this.state.deletepopup)
      }
    })
  }
  handleDelete = () => {
    this.setState({ deletepopup:false }, () => {
      const { deletePopupStatus } = this.props;
      if(deletePopupStatus) {
        deletePopupStatus(this.state.deletepopup)
      }
    })
    const { id, activeQuery, remainningRecords,currentPage } = this.props;
    if (!id) return;
    this.props.deleteActionListener(id, activeQuery, remainningRecords,currentPage);
  };
  render() {
    const { deletepopup } = this.state
    const { disable = false } = this.props;
    return (
      <>
      <button disabled={ (this.props.checkPermission && !disable) ? null : 'disabled' } onClick={ this.handlePopup }>
        <Delete className='fill-red' />
      </button>
      { deletepopup &&
      <Popup popupText='Are you sure you want to delete this?' handleYes={ this.handleDelete } handleCancel={ this.closePopUp } />
      }
      </>

    );
  }
}
